// Generated by scripts/add-language.js. Do not edit this file manually.
import type { TranslationTable } from '../i18n'
import language_ar from './ar.json'
import language_ru from './ru.json'

export const customTables: Record<string, TranslationTable> = {
  "ar": language_ar,
  "ru": language_ru,
}

export const customAliases: Record<string, string> = {
  "arabic": "ar",
  "ar": "ar",
  "russian": "ru",
  "ru": "ru",
}

export const customLocales: Record<string, string> = {
  "ar": "ar-EG",
  "ru": "ru-RU",
}

export const customRtlLanguages: string[] = ["ar"]
